import './assets/css/Footer.css';

export default function Footer() {
    return (
        <div className="footer">
            <p>Designed & Built by Faizaan Vidhani © 2023</p>
        </div>
    )
}